var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoFacebook1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.455,
    height: 20.453,
    viewBox: "0 0 20.455 20.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M206.261,311.55a10.228,10.228,0,1,1-10.013-10.218A10.223,10.223,0,0,1,206.261,311.55Zm-7.4,0,.2-2.221h-2.029c0-.517-.016-1.02.006-1.522.014-.312.182-.446.5-.455.347-.009.695,0,1.042,0h.47v-2.289a1.158,1.158,0,0,0-.116-.013c-.612,0-1.224-.007-1.836,0a4.048,4.048,0,0,0-1.236.185,2.02,2.02,0,0,0-1.191.954,2.711,2.711,0,0,0-.3,1.279c-.009.569,0,1.139,0,1.708v.166h-1.368v2.24h1.372v6.575h2.649v-6.606Z",
    transform: "translate(-185.806 -301.33)",
    fill: "#273375"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoFacebook1);
export default __webpack_public_path__ + "static/media/picto_facebook_1.63d6e67abd9732926ad3666d39fe5cd9.svg";
export { ForwardRef as ReactComponent };